<template>
  <div class="afterEval communityEvaluation img_video">
    <div class="list">
      <ul>
        <li v-for="(item, index) of list" :key="index">
          <div class="product">
            <div v-if="list && list.length <= 1 && list.length > 0" class="productBox">
              <img v-lazy="item.img_path">
              <div class="proContent">
                <b>{{item.name}}</b>
                <p>
                  <b>{{item.spec}}</b>
                </p>
              </div>
            </div>
            <div v-if="list && list.length > 1" class="productBox bestSellingSwiper" style="overflow: hidden;position:relative;">
              <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide :key="idx">
                  <img v-lazy="item.img_path">
                </swiper-slide>
              </swiper>
            </div>
            <span class="totelPrice">
              <span class="price">
                {{String(parseFloat(item.price).toFixed(2)).slice(0, String(parseFloat(item.price).toFixed(2)).indexOf('.'))}}
                <i>
                 {{String(parseFloat(item.price).toFixed(2)).slice(String(parseFloat(item.price).toFixed(2)).indexOf('.'), String(parseFloat(item.price).toFixed(2)).length)}}
                </i>
              </span>
              <b>共{{item.nums}}件</b>
            </span>
          </div>
        </li>
      </ul>
    </div>
    <article>
      <textarea v-model="textinput" name="" id="afterEval" placeholder="评价内容描述" @blur="input_blur"></textarea>
      <p>{{textNum}}/200</p>
      <div class="evalPhotoBox">
        <div v-if="fileVideoList && fileVideoList.length && fileVideoList[0].content" class="image van-uploader">
          <div class="van-uploader__wrapper">
            <div class="van-uploader__upload" :class="{'fullscreen': isfullscreen}" style="position: relative;width: 0.75rem;height: 0.75rem;background: #333333;">
              <video
                @click="playFn"
                crossOrigin="anonymous"
                class="videofile"
                id="videofile"
                :src="fileVideoList[0].content"
                @loadeddata="loadedmetadata"
                webkit-playsinline="true"
                playsinline="true"
                x5-playsinline="true"
                x-webkit-airplay="allow"
                preload="true"
              >
                <source :src="fileVideoList[0].content" type="video/mp4" />
                您的浏览器不支持 video 标签。
              </video>
              <div
                v-if="poster.length > 0"
                style="
                width: 1.05rem;
                height: 1.05rem;
                display: flex;
                justify-content: center;
                align-items: center;background: #333333;" class="van-uploader__preview-image play">
                <img style="width: 100%;" @click="playFn" :src="poster[0].content"/>
              </div>
              <img @click="playFn" v-if="!isfullscreen" src="/static/images/community/video.png" class="play">
              <i class="van-icon van-icon-clear van-uploader__preview-delete" @click="fileVideoList = [];poster = []"></i>
              <button class="poster">{{poster.length > 0 ? '更换封面' : '添加封面'}}</button>
              <van-uploader
                v-if="!isfullscreen"
                v-model="poster"
                class="poster-upload"
              >
                <button class="poster"></button>
              </van-uploader>
            </div>
          </div>
        </div>
        <van-uploader
          v-if="!(fileVideoList && fileVideoList.length)"
          class="video"
          :class="{'no_margin': fileList.length && !fileVideoList.length}"
          :compressed="false"
          v-model="fileVideoList"
          :max-count="fileList && fileList.length >= 6 ? 0 : 1"
          accept="video/*"
          preview-size="0.75rem"
          :before-read="beforeRead"
          :after-read="afterRead"
        />
        <van-uploader
          class="image"
          :class="{'marginLeft_image': !fileList.length, 'nomarginLeft_image': fileList && fileList.length >= 6}"
          :multiple="true"
          v-model="fileList"
          :max-count="!(fileVideoList && fileVideoList.length) ? 6 : 5"
          preview-size="0.75rem"
          :after-read="afterReadFile"
        />
        <span>最多上传6张图片，或最多上传1个视频，5张图片</span>
      </div>
    </article>
    <div class="contact" style="margin-bottom: 0.1rem">
      <div class="contactTitle">
        <b>评分</b>
        <p>客观打分，有助于我们改进工作哦～</p>
      </div>
      <van-rate v-model="value" void-color="#eee" void-icon="star" size="15" />
    </div>
    <div class="goldfans" style="margin-bottom: 0.1rem">
      <div class="flex-js-ac">
        <div class="contactTitle">
          <b style="white-space: nowrap">同步金粉秀</b>
        </div>
        <van-checkbox v-model="checked" icon-size="17" checked-color="#FC0324"></van-checkbox>
      </div>
      <p style="margin-top: 0.1rem;">图片与视频需上传原创内容且与产品相关，使用商城图片截图视为无效</p>
    </div>
    <div class="footerIOS" style="min-height: 0.63rem"></div>
    <footer class="footerIOS">
      <button class="btn" @click="submit">提交</button>
    </footer>
  </div>
</template>

<script>
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'
import { customRequestAjax } from '@/axiosApi'
import { isWeixin, fenxiang } from '../../assets/common/js/config'
import Vue from 'vue'
Vue.use(VueAwesomeSwiper, /* { default global options } */)
// const OSS = require('ali-oss').Wrapper
export default {
  name: 'afterEvaluation',
  data () {
    return {
      list: [],
      fileVideoList: [], // 视频file
      fileList: [],
      fileLen: null,
      poster: [], // 视频封面file
      imgpath: [], // 图片地址
      videopath: '', // 视频地址
      videoposter: '', // 视频封面
      isfullscreen: false,
      swiperOption: {
        autoplay: false,
        slidesPerView: 'auto',
        spaceBetween: 5,
        pagination: {
          el: '#bestSellingSwiperPagination',
          type: 'progressbar'
          // progressbarFillClass: 'swiper-pagination-progressbar'
        }
      },
      textinput: '',
      textNum: 0,
      value: 5,
      checked: false,
      issubmit: false
    }
  },
  mounted: function () {
    if (isWeixin()) {
      fenxiang({path: 'productevaluation'})
    }
    this.list = []
    if (sessionStorage.getItem('evaluate_product')) {
      this.list.push(JSON.parse(sessionStorage.getItem('evaluate_product')))
      console.log(this.list)
    }
  },
  destroyed: function () {
    this.$toast.clear()
    this.$dialog.close()
  },
  watch: {
    textinput (n) {
      if (n.length > 200) {
        this.textNum = 200
      } else {
        this.textNum = n.length
      }
      this.textinput = this.textinput.slice(0, 200)
      console.log(n.length)
    }
  },
  methods: {
    playFn: function () {
      this.isfullscreen = !this.isfullscreen
      if (this.isfullscreen) {
        document.getElementById('videofile').play()
      } else {
        document.getElementById('videofile').pause()
      }
    },
    afterRead: function () {
      this.$nextTick(function () {
        const video = document.getElementById('videofile')
        video.load()
      })
    },
    beforeRead: function (file) {
      console.log(file)
      var that = this
      return new Promise(function (resolve, reject) {
        var fileUrl = URL.createObjectURL(file)
        var audioElement = new Audio(fileUrl)
        var duration
        if (isWeixin()) {
          resolve()
        } else {
          f()
        }
        function f () {
          audioElement.addEventListener('loadedmetadata', function (event) {
            duration = audioElement.duration
            if (duration <= 10) {
              that.$toast('视频最短要10秒哦！')
              reject()
            } else if (duration / 60 > 3) {
              that.$toast('视频内容不能超过3分钟哦！')
              reject()
            }
            resolve()
          })
        }
      })
    },
    loadedmetadata: function () {
      const video = document.getElementById('videofile')
      console.log(video.duration)
    },
    afterReadFile: function (file) {
      // console.log('afterReadFile', file)
      setTimeout(() => {
        this.addTouchEvent()
      })
    },
    addTouchEvent: function () {
      let domlist = document.querySelectorAll('.van-uploader__preview'),
        touchStartTime,
        that = this
      if (domlist) {
        let domMoveFlag = true
        domlist.forEach((item, index) => {
          item.ontouchstart = null
          item.ontouchmove = null
          item.ontouchend = null
          item.ontouchstart = (startEvent) => {
            // console.log(startEvent)
            if (startEvent.currentTarget.className.indexOf('van-uploader__preview') < 0) return
            // startEvent.preventDefault()
            touchStartTime = new Date()
            setTimeout(() => {
              if (domMoveFlag) {
                // console.log('执行元素位置操作过程')
                that.showDeleteArea = true
                let domClient = item.getBoundingClientRect()
                // console.log('domClient', domClient)
                let firstPosition = {
                  x: startEvent.changedTouches[0].pageX,
                  y: startEvent.changedTouches[0].pageY
                }
                item.style.position = 'fixed'
                item.style.top = domClient.top / 100 + 'rem'
                item.style.left = domClient.left / 100 + 'rem'
                item.style.zIndex = 9
                // 添加拖拽事件
                item.ontouchmove = (moveEvent) => {
                  if (moveEvent.currentTarget.className.indexOf('van-uploader__preview') < 0) return
                  let time = new Date()
                  if (time - touchStartTime > 600) {
                    item.style.top = (moveEvent.changedTouches[0].pageY - firstPosition.y + domClient.top) / 100 + 'rem'
                    item.style.left = (moveEvent.changedTouches[0].pageX - firstPosition.x + domClient.left) / 100 + 'rem'
                    // console.log('top', item.style.top, moveEvent.changedTouches[0].pageY, firstPosition.y, domClient.top)
                    // console.log('left', item.style.left, moveEvent.changedTouches[0].pageX, firstPosition.x, domClient.left)
                  }
                }
              }
            }, 600)
          }
          item.ontouchend = (endEvent) => {
            if (endEvent.currentTarget.className.indexOf('van-uploader__preview') < 0) return
            let time = new Date()
            // console.log(time - touchStartTime)
            if (time - touchStartTime <= 400) {
              domMoveFlag = false
              item.click()
              setTimeout(() => {
                that.addTouchEvent()
              })
            } else {
              let newItemCenter = item.getBoundingClientRect(),
                centerY = newItemCenter.top + newItemCenter.height / 2,
                centerX = newItemCenter.left + newItemCenter.width / 2
              // deleteDom = document.querySelector('.deleteImg'),
              // deleteArea = deleteDom.getBoundingClientRect()
              // if (centerY >= deleteArea.top) {
              //   let _imgList = JSON.parse(JSON.stringify(that.fileList))
              //   let currentImg = _imgList.splice(index, 1)
              //   that.fileList = []
              //   that.showDeleteArea = false
              //   setTimeout(() => {
              //     that.fileList = _imgList
              //     console.log(that.fileList)
              //     setTimeout(() => {
              //       that.addTouchEvent()
              //     })
              //   })
              //   return
              // }
              that.showDeleteArea = false
              // 计算所有图片元素所在页面位置
              let domParentList = document.querySelectorAll('.van-uploader__preview')
              domParentList && domParentList.forEach((domParent, cindex) => {
                let domPos = domParent.getBoundingClientRect()
                if (
                  centerY >= domPos.top &&
                  centerY <= domPos.bottom &&
                  centerX >= domPos.left &&
                  centerX <= domPos.right
                ) {
                  // 重新排序
                  console.log('在目标区域内，重新排序')
                  let _imgList = JSON.parse(JSON.stringify(that.fileList))
                  let currentImg = _imgList.splice(index, 1)
                  _imgList.splice(cindex, 0, ...currentImg)
                  that.fileList = []
                  console.log(cindex, _imgList, currentImg)
                  that.fileList = _imgList
                  that.addTouchEvent()
                }
              })
              // 还原样式
              item.style.position = 'relative'
              item.style.top = 'auto'
              item.style.left = 'auto'
              item.style.zIndex = 1
            }
          }
        })
      }
    },
    uploadImage (filllist, file, index, format, type, fn) {
      if ((file.url && file.url.indexOf('https://') >= 0) || (file.content && file.content.indexOf('https://') >= 0)) {
        index++
        var path = file.url ? file.url.replace('Uploads/', '') : file.content.replace('Uploads/', '')
        // video
        // videoposter
        // imgpath
        if (type == 'imgpath' || type == 'videoposter') {
          path = file.url ? file.url.split('Uploads/')[1] : file.content.split('Uploads/')[1]
        } else {
          path = file.content
        }
        if (type == 'imgpath') {
          this.imgpath.push(path)
        } else if (type == 'video') {
          this.videopath = path
        } else if (type == 'videoposter') {
          this.videoposter = path
        }
        if (index >= filllist.length) {
          if (typeof fn === 'function') {
            fn()
          }
        } else {
          this.uploadImage(filllist, filllist[index], index, format, type, function () {
            if (typeof fn === 'function') {
              fn()
            }
          })
        }
        return
      }
      var imgName = 'comments'
      var blob = this.dataURLtoBlob(file.content)
      var newFile = this.blobToFile(blob, imgName)
      var url = this.ossUrl
      var that = this
      customRequestAjax(url).then(async res => {
        if (res.data.code === 200) {
          const {
            accessid,
            host,
            policy,
            signature,
            dir
          } = res.data.data
          const fd = new FormData()
          let str = that.random_string(16) + newFile.name + format
          fd.append('OSSAccessKeyId', accessid)
          fd.append('policy', policy)
          fd.append('Signature', signature)
          fd.append('key', `${dir}${str}`)
          fd.append('Filename', `${dir}${str}`)
          fd.append('success_action_status', 200)
          fd.append('file', newFile)
          let config = {
            // 添加请求头
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
          that.$axios.post(host, fd, config).then(res => {
            console.log(res)
            if (res.status == 200 && res.statusText == 'OK') {
              // var img = that.imgUrl + `${dir}${str}`
              var path = `${dir}${str}`.replace('Uploads/', '')
              if (type == 'imgpath') {
                that.imgpath.push(path)
              } else if (type == 'video') {
                that.videopath = path
              } else if (type == 'videoposter') {
                that.videoposter = path
              }
              index++
              if (index >= filllist.length) {
                if (typeof fn === 'function') {
                  fn()
                }
              } else {
                that.uploadImage(filllist, filllist[index], index, format, type, function () {
                  if (typeof fn === 'function') {
                    fn()
                  }
                })
              }
            }
          })
        }
      })
    },
    // 将base64转换为blob
    dataURLtoBlob: function(dataurl) {
      var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    // 将blob转换为file
    blobToFile: function(theBlob, fileName){
      theBlob.lastModifiedDate = new Date()
      theBlob.name = fileName
      return theBlob
    },
    random_string: function (n) {
      var num = Math.pow(10, n)
      return Math.ceil(Math.random() * num) + '' + new Date().getTime()
    },
    submit: function () {
      if (this.issubmit) {
        return
      }
      this.issubmit = true
      if (this.checked && (!this.fileList.length && !this.fileVideoList.length)) {
        this.issubmit = false
        this.$toast('同步上传金粉秀，需上传视频/照片哦')
        return
      } else if (this.textinput.trim() == '') {
        this.issubmit = false
        this.$toast('评价内容不能为空哦')
        return
      }
      this.$toast.loading({
        mask: true,
        message: '正在提交',
        duration: 0
      })
      this.fileLen = 0
      this.imgpath = []
      var that = this
      if (that.fileVideoList.length > 0) {
        that.uploadImage(that.fileVideoList, that.fileVideoList[0], 0, '.mp4', 'video', function () {
          if (that.poster.length) {
            that.uploadImage(that.poster, that.poster[0], 0, '.png', 'videoposter', function () {
              if (that.fileLen < that.fileList.length) {
                that.uploadImage(that.fileList, that.fileList[that.fileLen], that.fileLen, '.png', 'imgpath', function () {
                  that.submitAxios()
                })
              } else {
                that.submitAxios()
              }
            })
          } else {
            if (that.fileLen < that.fileList.length) {
              that.uploadImage(that.fileList, that.fileList[that.fileLen], that.fileLen, '.png', 'imgpath', function () {
                that.submitAxios()
              })
            } else {
              that.submitAxios()
            }
          }
        })
      } else if (that.fileLen < that.fileList.length) {
        that.uploadImage(that.fileList, that.fileList[that.fileLen], that.fileLen, '.png', 'imgpath', function () {
          that.submitAxios()
        })
      } else if (that.fileVideoList.length == 0 && that.fileList.length == 0) {
        that.submitAxios()
      }
    },
    submitAxios: function () {
      var url = 'Wxmall/Comment/addCommentByOrder'
      var that = this
      console.log(that.imgpath)
      this.$ckeckgraphic({
        content: that.textinput,
        images: that.imgpath.length > 0 ? that.imgpath.join() : '',
        callback: () => {
          var data = {
            orderid: that.$route.query.orderid,
            itemid: that.$route.query.skuid,
            itemscore: that.value,
            content: that.textinput,
            videopath: that.videopath ? that.videopath : '',
            coverimg: that.videoposter ? that.videoposter : that.videopath ? (that.videopath + '?x-oss-process=video/snapshot,t_0,f_jpg,ar_h') : '',
            path1: that.imgpath[0] ? that.imgpath[0] : '',
            path2: that.imgpath[1] ? that.imgpath[1] : '',
            path3: that.imgpath[2] ? that.imgpath[2] : '',
            path4: that.imgpath[3] ? that.imgpath[3] : '',
            path5: that.imgpath[4] ? that.imgpath[4] : '',
            path6: that.imgpath[5] ? that.imgpath[5] : '',
            item_base_id: that.$route.query.itemid,
            isgoodcomment: that.checked ? 1 : 0
          }
          customRequestAjax.post(url, data).then(res => {
            if (res.data.code === 200) {
              that.$router.go(-1)
              sessionStorage.removeItem('evaluate_product')
            } else {
              that.issubmit = false
            }
          })
        },
        errcallback () {
          that.issubmit = false
        }
      })
    },
    input_blur () {
      // document.body.scrollTop = document.documentElement.scrollTop - 1
      setTimeout(() => {
        var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0
        window.scrollTo(0, Math.max(scrollHeight, 0))
      }, 100)
    },
    handlechange () {
      var reg = /(http:\/\/|https:\/\/)((\w|=|\?|\.|\/|&|-)+)/g;
      // var reg = /[^\u0020-\u007E\u00A0-\u00BE\u2E80-\uA4CF\uF900-\uFAFF\uFE30-\uFE4F\uFF00-\uFFEF\u0080-\u009F\u2000-\u201f\u2026\u2022\u20ac\r\n]/g;
      if (this.textinput.match(reg)) {
        this.textinput = this.textinput.replace(reg, '')
      }
      this.textinput = this.textinput.replace(/\s+/g, '')
    }
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/common/css/footerSubmit";
  .list ul li p, .product{
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    justify-content: space-between;
    -moz-justify-content: space-between;
    -ms-justify-content: space-between;
    -webkit-justify-content: space-between;
    -o-justify-content: space-between;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;
  }
  .afterEval {
    .list {
      background: #fff;
      margin: 0.1rem 0.11rem 0;
      padding: 0.2rem 0.15rem;
      border-radius: 0.03rem;
      >ul {
        >li {
          background: #fff;
          >p {
            border-bottom: 1px solid #EFEFEF;
            padding-bottom: 0.1rem;
            span {
              display: block;
              b {
                display: block;
                font-weight: 400;
                color: #444444;
                font-size:0.12rem;
                float: left;
                &:last-of-type {
                  margin-left: 0.04rem;
                }
              }
            }
            i {
              font-style: normal;
              color: #292929;
              font-size: 0.12rem;
              display: flex;
              display: -o-flex;
              display: -webkit-flex;
              display: -ms-flex;
              display: -moz-flex;
              align-items: center;
              -o-align-items: center;
              -webkit-align-items: center;
              -ms-align-items: center;
              -moz-align-items: center;
              b{
                border-left: 1px solid #D8D8D8;
                margin-left: 0.06rem;
                padding-left: 0.07rem;
                display: flex;
                display: -o-flex;
                display: -webkit-flex;
                display: -ms-flex;
                display: -moz-flex;
                align-items: center;
                -o-align-items: center;
                -webkit-align-items: center;
                -ms-align-items: center;
                -moz-align-items: center;
                img {
                  width:0.12rem;
                  height:0.12rem;
                }
              }
            }
          }
          .product {
            position: relative;
            .productBox {
              display: flex;
              display: -moz-flex;
              display: -ms-flex;
              display: -webkit-flex;
              display: -o-flex;
              img {
                width: 0.8rem;
                height: 0.8rem;
              }
              .proContent {
                margin-left: 0.07rem;
                margin-top: 0.08rem;
                flex: 1;
                -webkit-flex: 1;
                -moz-flex: 1;
                -ms-flex: 1;
                -o-flex: 1;
                >b {
                  font-size:0.13rem;
                  font-weight:400;
                  color:rgba(41,41,41,1);
                  line-height:0.18rem;
                  display: block;
                  margin-bottom: 0.05rem;
                }
                >p{
                  align-items: flex-start;
                  -moz-align-items: flex-start;
                  -ms-align-items: flex-start;
                  -webkit-align-items: flex-start;
                  -o-align-items: flex-start;
                  >b {
                    font-size:0.11rem;
                    font-weight:400;
                    color:rgba(108,108,108,1);
                    line-height:0.16rem;
                    display: block;
                  }
                }
              }
            }
            .totelPrice {
              z-index: 10;
              opacity:0.85;
              height: 0.8rem;
              display: flex;
              display: -webkit-flex;
              display: -o-flex;
              display: -ms-flex;
              display: -moz-flex;
              flex-direction: column;
              -webkit-flex-direction: column;
              -o-flex-direction: column;
              -ms-flex-direction: column;
              -moz-flex-direction: column;
              justify-content: center;
              -webkit-justify-content: center;
              -o-justify-content: center;
              -ms-justify-content: center;
              -moz-justify-content: center;
              .price {
                display: flex;
                display: -webkit-flex;
                display: -o-flex;
                display: -ms-flex;
                display: -moz-flex;
                align-items: flex-end;
                -webkit-align-items: flex-end;
                -o-align-items: flex-end;
                -ms-align-items: flex-end;
                -moz-align-items: flex-end;
                font-size: 0.14rem;
                font-weight:600;
                color:#222222;
                line-height:0.14rem;
                &:before {
                  content: '￥';
                  font-size:0.10rem;
                  font-weight:600;
                  line-height: 0.14rem;
                }
                i {
                  font-size: 0.11rem;
                  font-style: normal;
                  line-height: 0.14rem;
                }
              }
              >b {
                color: #908D8D;
                font-size: 0.11rem;
                line-height: 0.16rem;
                display: block;
                font-weight:400;
                text-align: center;
              }
            }
            .bestSellingSwiper {
              .swiper-container {
                padding-right: 0.6rem;
              }
              .swiper-wrapper {
                >.swiper-slide {
                  width: 0.8rem;
                  position: relative;
                  background-color: white;
                }
              }
              &+.totelPrice {
                background:rgba(255,255,255,1);
                box-shadow:-0.2rem 0 0.09rem -0.16rem rgba(156,156,156,0.5);
              }
            }
          }
        }
      }
    }
    article{
      background: #fff;
      margin: 0.1rem 0.11rem 0;
      padding: 0.2rem 0.15rem 0.2rem;
      border-radius: 0.04rem;
      .poster {
        background: rgba(0, 0, 0, 0.39) !important;
        border-radius: 0 0 0.03rem 0.03rem;
        border-width: 0;
        font-size: 0.1rem;
        color: #FFFFFF;
        width: 100%;
        height: 0.22rem;
        line-height: 0.22rem;
        display: block;
        position: absolute;
        left: 0;
        bottom: 0;
      }
      .poster-upload {
        height: 0.22rem;
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
        .poster {
          background: transparent !important;
        }
      }
      #afterEval {
        display: block;
        width: 100%;
        min-height: 1.43rem;
        border: none;
        outline: none;
        line-height: 0.18rem;
        font-size: 0.13rem;
        color: #333;
        &::placeholder {
          font-size: 0.13rem;
          color: #B0B0B0;
          line-height: 0.18rem;
        }
      }
      p {
        font-size: 0.11rem;
        color: #B0B0B0;
        text-align: right;
      }
      .evalPhotoBox {
        display: flex;
        align-items: flex-end;
        flex-wrap: wrap;
        position: relative;
        padding-bottom: 0.07rem;
        &:after {
          content: '';
          display: block;
          height: 0.005rem;
          width: 98%;
          position: absolute;
          background: #D8D8D8;
          bottom: 0;
        }
        span {
          display: block;
          font-size: 0.11rem;
          color: #B0B0B0;
          margin-bottom: 0.08rem;
        }
      }
    }
    .contact, .goldfans {
      height: 0.45rem;
      background: #fff;
      margin: 0.1rem 0.11rem 0.55rem;
      padding: 0 0.15rem;
      display: flex;
      display: -ms-flex;
      display: -webkit-flex;
      display: -moz-flex;
      display: -o-flex;
      align-items: center;
      -webkit-align-items: center;
      -o-align-items: center;
      -moz-align-items: center;
      -ms-align-items: center;
      justify-content: space-between;
      -ms-justify-content: space-between;
      -webkit-justify-content: space-between;
      -moz-justify-content: space-between;
      -o-justify-content: space-between;
      border-radius: 0.04rem;
      .contactTitle {
        flex: 1;
        -ms-flex: 1;
        -webkit-flex: 1;
        -moz-flex: 1;
        -o-flex: 1;
        b {
          display: block;
          font-size: 0.13rem;
          color: #000000;
          margin-right:0.08rem;
          float: left;
        }
        p {
          font-size:0.11rem;
          font-weight:400;
          color:rgba(176,176,176,1);
          line-height:0.2rem;
        }
      }
    }
    .goldfans {
      display: block;
      height: 0.88rem;
      padding: 0.14rem 0.15rem;
      p {
        font-size:0.11rem;
        font-weight:400;
        color:rgba(176,176,176,1);
        line-height:0.16rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/order/productEvaluation.vue